const localStorageMiddleware = ({ getState }) => {
    return (next) => (action) => {
        const result = next(action);
        localStorage.setItem("applicationState", JSON.stringify(getState()));
        return result;
    };
};
const sessionStorageMiddleware = ({ getState }) => {
    return (next) => (action) => {
        const result = next(action);
        try {
            const serializedState = JSON.stringify(getState());
            sessionStorage.setItem("applicationState", serializedState);
          } catch (error) {
            // Ignore write errors.
          }
        return result;
    };
};

const reHydrateStore = () => {
    if (localStorage.getItem("applicationState") !== null) {
        return JSON.parse(localStorage.getItem("applicationState")); // re-hydrate the store
    }
};
const reHydrateSessionStore = () => {
    try {
        const serializedState = sessionStorage.getItem("applicationState");
        if (serializedState === null) {
          return undefined;
        }
        return JSON.parse(serializedState);
      } catch (error) {
        return undefined;
      }
};

export {
    localStorageMiddleware,
    reHydrateStore,
    sessionStorageMiddleware,
    reHydrateSessionStore
}